/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useToast } from "@/hooks/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  is_new: z.boolean()?.optional(),
  map_using_filename: z.boolean()?.optional(),
  retailer_name: z.string().min(1, {
    message: "Retailer name is required.",
  }),
  synonym_mapping: z.string().optional(),
  divide_doc_to_chunks: z.boolean().optional(),
  auto_generate_reference_no: z.boolean().optional(),
  child_doc_synonym_mapping: z.string().optional(),
  // date_format: z.string().min(1, {
  //   message: "Date Format name is required.",
  // }),
  matching_keys: z.any(),
  retailer_code: z.any(),
  settings: z
    .object({
      delivery_date_settings: z
        .object({
          is_equal_to_order_date: z.boolean()?.optional(),
          today_date: z.boolean().optional(),
          days_after_order_date: z.any().optional(),
        })
        .optional(),
      order_date_format: z.any().optional(),
      delivery_date_format: z.any().optional(),
      supported_document_types: z.any().optional(),
      ignore_keys: z.any().optional(),
      branch_only_search: z.any().optional(),
      use_azure_ocr: z.boolean().optional(),
      use_textract_ocr: z.boolean().optional(),
      split_per_delivery_date: z.boolean().optional(),
      po_number_prefix: z.string().optional(),
      ignore_validation_failure: z.boolean().optional(),
      split_consolidated_orders: z.boolean().optional(),
      cost_ctr_wise_split: z.boolean().optional(),
      multi_page_document: z.boolean().optional(),
      order_date_settings: z
        .object({
          today_date: z.boolean()?.optional(),
          is_equal_to_delivery_date: z.boolean().optional(),
        })
        .optional(),
      default_uom_settings: z
        .array(
          z.object({
            default_custom_uom: z.string().min(1, {
              message: "Default custom uom is required.",
            }),
            sku: z.array(z.string()).optional(),
          }),
        )
        .optional()
        .optional(),
    })
    .optional(),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onSubmit",
    defaultValues: {
      is_new: false,
      map_using_filename: false,
      retailer_name: "",
      matching_keys: [],
      // date_format: "",
      synonym_mapping: "",
      retailer_code: "",
      child_doc_synonym_mapping: "",
      divide_doc_to_chunks: false,
      auto_generate_reference_no: false,
      settings: {
        delivery_date_settings: {
          is_equal_to_order_date: false,
          today_date: false,
          days_after_order_date: "",
        },
        order_date_format: "DD-MM-YYYY",
        delivery_date_format: "DD-MM-YYYY",
        supported_document_types: [],
        branch_only_search: false,
        use_azure_ocr: false,
        use_textract_ocr: false,
        ignore_validation_failure: false,
        split_per_delivery_date: false,
        po_number_prefix: "",
        split_consolidated_orders: false,
        cost_ctr_wise_split: false,
        multi_page_document: false,
        order_date_settings: {
          today_date: false,
          is_equal_to_delivery_date: false,
        },
        default_uom_settings: [],
      },
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
    if (formData?.settings?.delivery_date_settings?.is_equal_to_order_date) {
      form.setValue(
        "settings.delivery_date_settings.is_equal_to_order_date",
        formData.settings.delivery_date_settings.is_equal_to_order_date,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    }

    if (formData?.settings?.delivery_date_settings?.today_date) {
      form.setValue(
        "settings.delivery_date_settings.today_date",
        formData.settings.delivery_date_settings.today_date,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    }

    if (formData?.settings?.delivery_date_settings?.days_after_order_date) {
      form.setValue(
        "settings.delivery_date_settings.days_after_order_date",
        formData.settings.delivery_date_settings.days_after_order_date,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    }

    if (formData?.settings?.supported_document_types) {
      form.setValue(
        "settings.supported_document_types",
        formData.settings.supported_document_types,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.supported_document_types", [], {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.delivery_date_format) {
      form.setValue(
        "settings.delivery_date_format",
        formData.settings.delivery_date_format,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.delivery_date_format", "DD-MM-YYYY", {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.order_date_format) {
      form.setValue(
        "settings.order_date_format",
        formData.settings.order_date_format,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.order_date_format", "DD-MM-YYYY", {
        shouldTouch: true,
        shouldDirty: true,
      });
    }

    if (formData?.settings?.ignore_keys) {
      form.setValue("settings.ignore_keys", formData.settings.ignore_keys, {
        shouldTouch: true,
        shouldDirty: true,
      });
    } else {
      form.setValue("settings.ignore_keys", [], {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.branch_only_search) {
      form.setValue(
        "settings.branch_only_search",
        formData.settings.branch_only_search,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.branch_only_search", false, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.use_azure_ocr) {
      form.setValue("settings.use_azure_ocr", formData.settings.use_azure_ocr, {
        shouldTouch: true,
        shouldDirty: true,
      });
    } else {
      form.setValue("settings.use_azure_ocr", false, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.use_textract_ocr && !formData?.settings?.use_azure_ocr) {
      form.setValue(
        "settings.use_textract_ocr",
        formData.settings.use_textract_ocr,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.use_textract_ocr", false, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.order_date_settings?.today_date) {
      form.setValue(
        "settings.order_date_settings.today_date",
        formData?.settings?.order_date_settings?.today_date,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.order_date_settings.today_date", false, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.order_date_settings?.is_equal_to_delivery_date) {
      form.setValue(
        "settings.order_date_settings.is_equal_to_delivery_date",
        formData?.settings?.order_date_settings?.is_equal_to_delivery_date,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue(
        "settings.order_date_settings.is_equal_to_delivery_date",
        false,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    }
    if (formData?.settings?.default_uom_settings) {
      form.setValue(
        "settings.default_uom_settings",
        formData?.settings?.default_uom_settings,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.default_uom_settings", [], {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.multi_page_document) {
      form.setValue(
        "settings.multi_page_document",
        formData?.settings?.multi_page_document,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    } else {
      form.setValue("settings.multi_page_document", false, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    console.log({ values });
    const { data } = await onFormSubmit(values);
    if (data) {
      // toast({
      //   title: "Success",
      //   variant: "success",
      //   description: data.status.msg,
      // });
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
